<style scoped lang="less">
.category{
  width: 100%;
  flex: none !important;
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  box-sizing: border-box;
}
</style>
<script>
import methods from './methods.js'
import Container from "modules/shop/_id/components/container/index.vue";
import ButtonGroup from "modules/shop/_id/components/buttonGroup/index.vue";
import Chart from './components/chart/index.vue'
import List from './components/list/index.vue'
export default {
  name: "price",
  components: {ButtonGroup, Container,Chart,List},
  mixins: [methods]
}
</script>
<template>
 <Container icon=" https://s6.bihukankan.com/img/1695710294509.svg" title="直播分销构成">
    <template #head>
      <ButtonGroup v-model="filter" :list="buttonList" @change="getData"/>
    </template>
    <div class="category">
      <none-data :height="3.5" v-if="isEmpty"></none-data>
      <template v-else>
        <Chart :type="filter" :data="chartDataApi"/>
        <List :type="filter" :data="chartDataApi"/>
      </template>
    </div>
  </Container>
</template>

